module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 6296,
			"name": "Fix Small WordPress Issues",
			"url": "https://studio.envato.com/explore/wordpress-customization/6296-fix-small-wordpress-issues",
			"price_from": 50
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		},
		{
			"id": 39424,
			"name": "Professional Flat Style Homepage Design",
			"url": "https://studio.envato.com/explore/new-website/39424-premium-professional-flat-style-homepage-design-psd",
			"price_from": 190
		},
		{
			"id": 2349,
			"name": "Premium Flyer Design",
			"url": "https://studio.envato.com/explore/poster-flyer-design/2349-premium-flyer-design",
			"price_from": 50
		},
		{
			"id": 7825,
			"name": "Professional WordPress Theme Customization",
			"url": "https://studio.envato.com/explore/wordpress-customization/7825-professional-wordpress-theme-customization",
			"price_from": 100
		},
		{
			"id": 6500,
			"name": "Customisation of Keynote or Powerpoint Presentations",
			"url": "https://studio.envato.com/explore/presentation-design/6500-customisation-of-keynote-or-powerpoint-presentations",
			"price_from": 225
		},
		{
			"id": 14872,
			"name": "WordPress Theme Setup & Design Customization",
			"url": "https://studio.envato.com/explore/wordpress-installation/14872-wordpress-theme-setup-design-customization",
			"price_from": 250
		},
		{
			"id": 1453,
			"name": "Effective Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design",
			"price_from": 55
		},
		{
			"id": 23385,
			"name": "High Quality Website Content",
			"url": "https://studio.envato.com/explore/website-content/23385-high-quality-website-content-one-page",
			"price_from": 90
		},
		{
			"id": 9390,
			"name": "Professional Custom HD Logo Reveal",
			"url": "https://studio.envato.com/explore/logo-animation/9390-professional-custom-hd-logo-reveal",
			"price_from": 140
		},
		{
			"id": 7368,
			"name": "WordPress Theme Customization",
			"url": "https://studio.envato.com/explore/wordpress-customization/7368-wordpress-theme-customization-with-a-smile",
			"price_from": 175
		},
		{
			"id": 24158,
			"name": "Blog/Article Writing",
			"url": "https://studio.envato.com/explore/blog-article-writing/24158-blog-article-writing-up-to-1000-words",
			"price_from": 80
		},
		{
			"id": 7205,
			"name": "Mobile Application UI Designing",
			"url": "https://studio.envato.com/explore/app-design/7205-mobile-application-ui-designing",
			"price_from": 280
		},
		{
			"id": 6084,
			"name": "Convert HTML to WordPress",
			"url": "https://studio.envato.com/explore/website-to-wordpress/6084-convert-html-to-wordpress",
			"price_from": 250
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/themeforest.json
// module id = 237
// module chunks = 1 2